/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import { forIn } from 'lodash';

const REACT_FUNCTIONS = {
	autobind: 1,
	childContextTypes: 1,
	componentDidMount: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentWillReceiveProps: 1,
	componentWillUnmount: 1,
	componentWillUpdate: 1,
	contextTypes: 1,
	displayName: 1,
	forceUpdate: 1,
	getChildContext: 1,
	getDefaultProps: 1,
	getInitialState: 1,
	isMounted: 1,
	mixins: 1,
	render: 1,
	replaceProps: 1,
	replaceState: 1,
	setProps: 1,
	setState: 1,
	shouldComponentUpdate: 1,
	statics: 1,
	updateComponent: 1,
};

export default function hoistInstance(dest, source) {
	forIn(source, (v, key) => {
		if (
			typeof source[key] === 'function' &&
			key.charAt(0) !== '_' &&
			!REACT_FUNCTIONS[key] &&
			dest[key] === undefined
		) {
			dest[key] = source[key].bind(source); // eslint-disable-line no-param-reassign
		}
	});
}
